import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import Swal from "sweetalert2";



const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const Table = styled.table`
  width: 98%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    display: block;
  }
`;


const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.3);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;

  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 640px) {
    ${(props) => props.onlyWeb && "display: none;"}
  }
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none;"}
  }
  @media (max-width: 420px) {
    ${(props) => props.onlyWeb && "display: none;"}
  }
`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  @media (max-width: 640px) {
    padding-left: 10px;
    ${(props) => props.onlyWeb && "display: none"}
  }
  @media (max-width: 420px) {
    padding-left: 10px;
    ${(props) => props.onlyWeb && "display: none"}
    
  }
`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  @media (max-width: 640px) {
    display: flex;
    flex-direction: row;
    padding-left: 10px;

    ${(props) => props.onlyWeb && "width: 80%"}

  }
  @media (max-width: 420px) {
    display: flex;
    flex-direction: row;
    padding-left: 10px;

    ${(props) => props.onlyWeb && "width: 80%"}
  }
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  @media (max-width: 640px) {
    display: flex;

    padding-left: 10px;
    width: 150px;
    ${(props) => props.onlyWeb && "display: none"}
    ${(props) => props.onlyWeb3 && "width: 80%"}
  }
  @media (max-width: 420px) {
    display: flex;

    padding-left: 10px;
    width: 150px;
    ${(props) => props.onlyWeb && "display: none"}
    ${(props) => props.onlyWeb3 && "width: 80%"}
  }
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;
  span{
    margin: 0px 5px;
  }

  @media (max-width: 1360px) {
    width: 1200px;
  };
`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;

  @media (max-width: 640px) {
    width: 520px;
    height: 30px;
  }
  @media (max-width: 420px) {
    width: 220px;
    height: 35px;
  }
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  font-size: 16px;
  font-weight: bold;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
display: flex;
align-items: center;

  
  span{
    padding: 0px  10px;
  }
`;

const Grid = ({ setOnEdit, urlApi, paginas, fetchPagina, modalNovoModulo, modalNovaPagina, modalUsuarios }) => {

  //Token da api
  const token = localStorage.getItem('token');



  //---------------------------------------MODAL NOVO MODULO---------------------------------------------------//

  // Chama o modal de cadastrar usuários
  const handleNovoModulo = () => {
    modalNovoModulo();
  };

  //---------------------------------------MODAL NOVA PAGINA---------------------------------------------------//

  // Chama o modal de cadastrar usuários
  const handleNovaPagina = () => {
    modalNovaPagina();
  };

  //---------------------------------------MODAL EDITAR PAGINA---------------------------------------------------//

  const handleEdit = (item) => {
    modalNovaPagina();
    setOnEdit(item);
  };

  const handleUser = (item) => {
    modalUsuarios();
    setOnEdit(item);
  };

  //---------------------------------------DELETAR A PAGINA---------------------------------------------------//
  //PopUp de confirmação
  const showPopUp = (detalhes) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de deletar a tela ${detalhes}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };

  // Deleta os usuários
  const handleDelete = async (item) => {
    const detalhes = `${item.DESC_MODULO} - ${item.DESC_PAGINA}`

    const userConfirmed = await showPopUp(detalhes);
    if (!userConfirmed) {
      return;
    }


    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}gestao/paginas/${item.ID_PAGINA}`, {
        headers: { Authorization: `Bearer ${token}` },
      });


      toast.success("Página deletada com sucesso.");


    } catch (error) {
      // Tratamento de erros
      console.error('Erro ao deletar o página:', error);

      let errorMessage = 'Erro desconhecido ao deletar.';
      if (error.response) {
        errorMessage = error.response.data || errorMessage;
        console.log('Erro na resposta:', error.response);
      } else if (error.request) {
        console.log('Erro na requisição:', error.request);
      } else {
        console.log('Erro na configuração da requisição:', error.message);
      }

      toast.error(errorMessage);


    }
    fetchPagina();
    setOnEdit(null);
  };








  //-----------------------------------------///
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(paginas);




  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = paginas.filter((item) => {
        const modulo = (item.DESC_MODULO || '').toString().toLowerCase();
        const pagina = (item.DESC_PAGINA || '').toString().toLowerCase();



        return (
          modulo.includes(term.toLowerCase()) ||
          pagina.includes(term.toLowerCase())
        );
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {

    handleSearch(searchTerm);
  }, [searchTerm, paginas]);




  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//

  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);




  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };
  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  return (

    <Container>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar...módulo ou página"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>

        <Div>
          <Button onClick={handleNovoModulo}>
            <FaPlus size={20} color="gold" />Novo módulo
          </Button>
        </Div>
        <Div>

          <Button onClick={handleNovaPagina}>
            <FaPlus size={20} color="gold" />Nova Página
          </Button>

        </Div>
      </Td3>
      <Table >
        <Thead>

          <Tr>
            <Th onClick={() => onColumnClick("DESC_MODULO")} className={getSortClass("DESC_MODULO")}>
              Módulo: {getSortIcon("DESC_MODULO")}
            </Th>
            <Th onClick={() => onColumnClick("DESC_PAGINA")} className={getSortClass("DESC_PAGINA")}>
              Página: {getSortIcon("DESC_PAGINA")}
            </Th>
            <Th onClick={() => onColumnClick("URL")} className={getSortClass("URL")}>
              Link: {getSortIcon("URL")}
            </Th>
            <Th></Th>
            <Th></Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item, i) => (
            <Tr key={i}>
              <Td width="10%">{item.DESC_MODULO}</Td>

              <Td width="10%">{item.DESC_PAGINA}</Td>
              <Td width="auto">{item.URL}</Td>
              <Td>
                <TdButton width="auto" onClick={() => handleUser(item)}>
                  Usuários
                </TdButton>
              </Td>
              <Td>
                <TdButton width="auto" onClick={() => handleEdit(item)}>
                  Editar
                </TdButton>
              </Td>
              <Td>
                <TdButton width="auto" onClick={() => handleDelete(item)}>
                  Deletar
                </TdButton>
              </Td>


            </Tr>
          ))}
        </Tbody>


      </Table>

    </Container>
  );
};


export default Grid;
